import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// THE APERTURE — the sheet seen edge-on. One gold hairline that rises as a room boundary
// passes the viewer's eye line, with the next room's light leaking in behind it.
export default function Aperture() {
  const { pathname } = useLocation();
  const line = useRef(null);
  const leak = useRef(null);

  useEffect(() => {
    if (pathname !== "/" || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    let raf = 0;
    const paint = () => {
      raf = 0;
      const vh = window.innerHeight;
      let k = 0;
      document.querySelectorAll("[data-room-boundary]").forEach((el) => {
        const d = (el.getBoundingClientRect().top - vh * 0.5) / (vh * 0.55);
        k = Math.max(k, 1 - Math.min(1, Math.abs(d)));
      });
      const eased = k * k * (3 - 2 * k);
      if (line.current) {
        line.current.style.transform = `translate(-50%, -50%) scaleY(${eased})`;
        line.current.style.opacity = String(eased * 0.9);
      }
      if (leak.current) leak.current.style.opacity = String(eased * 0.55);
    };
    const onScroll = () => { if (!raf) raf = requestAnimationFrame(paint); };
    paint();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, [pathname]);

  if (pathname !== "/") return null;
  return (
    <div aria-hidden="true" data-testid="aperture" className="pointer-events-none fixed inset-0 z-20">
      <div
        ref={leak}
        className="absolute left-1/2 top-1/2 h-[80vh] w-[46vw] -translate-x-1/2 -translate-y-1/2"
        style={{ opacity: 0, background: "radial-gradient(ellipse at center, rgba(132,223,244,0.16) 0%, rgba(132,223,244,0.05) 35%, rgba(3, 3, 5,0) 70%)" }}
      />
      <div
        ref={line}
        className="absolute left-1/2 top-1/2 h-[58vh] w-px"
        style={{ opacity: 0, transform: "translate(-50%, -50%) scaleY(0)", background: "linear-gradient(180deg, rgba(132,223,244,0) 0%, #84DFF4 18%, #fff 50%, #84DFF4 82%, rgba(132,223,244,0) 100%)", boxShadow: "0 0 18px rgba(132,223,244,0.45)" }}
      />
    </div>
  );
}
